import React, { useState } from 'react';

import { Button, Col, Form, Input, InputNumber, Row, Select, Space, Switch, Typography } from 'antd';
import { PDFDocument, TextAlignment } from 'pdf-lib';

import { postGiftCode } from '../../../api/Post';

import ccPDF from './23-11-17-cc.pdf';

const { Text, Title } = Typography;

const GiftCode = () => {
  const [msgErr, setMsgErr] = useState('');

  const onFinish = async values => {
    // console.log("Success:", values);
    const res = await postGiftCode(values);
    // console.log(res);
    if (res.error) setMsgErr(res.error);
    else {
      if (values.exportPDF) {
        for (let i = 0; i < res.data.length; i++) {
          const oneGift = res.data[i];
          await createForm(oneGift.code, oneGift.aboType);
        }
      } else {
        const blob = new Blob([res.data], { type: 'text/csv' });
        downloadBlobFile(blob, `nbk_gift_codes-${values.companyCode}.csv`);
      }
    }
  };

  async function createForm(code, duration) {
    const fetchedRes = await fetch(ccPDF);
    const stringRes = await fetchedRes.arrayBuffer();

    const pdfDoc = await PDFDocument.load(stringRes);

    const form = pdfDoc.getForm();

    const monthField = form.getTextField('text_1cntp');
    const codeField = form.getTextField('text_2osci');

    codeField.setText(code);
    monthField.setText(`${duration}`);

    monthField.setFontSize(36);
    monthField.setAlignment(TextAlignment.Center);

    form.flatten();

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    downloadBlobFile(blob, `${code}.pdf`);
  }

  function downloadBlobFile(blob, name) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', name);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  return (
    <>
      <Space
        style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: 5,
          padding: 15,
          width: '100%',
        }}
        direction="vertical">
        <Title level={4} style={{ marginBottom: 20 }}>
          Générer des codes cadeaux
        </Title>
        <Form
          name="basic"
          initialValues={{
            aboType: 1,
            addToReport: true,
            exportPDF: true,
            qtCode: 1,
            timeUnit: 'm',
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical">
          <Row gutter={16}>
            <Col flex="auto">
              <Form.Item
                label="Nom de l'entreprise"
                name="companyName"
                rules={[{ message: 'Please input a company name!', required: true }]}>
                <Input placeholder="Nabook" maxLength={125} minLength={1} />
              </Form.Item>
            </Col>
            <Col flex="auto">
              <Form.Item
                label="Code entreprise"
                name="companyCode"
                rules={[{ message: 'Please input a company code!', required: true }]}>
                <Input placeholder="NBK" maxLength={3} minLength={1} />
              </Form.Item>
            </Col>
            <Col flex="auto">
              <Form.Item label="Quantité" name="qtCode" rules={[{ message: 'Please input a quantity!', required: true }]}>
                <InputNumber min={1} max={200} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col flex="none">
              <Form.Item
                label="Durée de l'abonnement"
                name="aboType"
                rules={[{ message: 'Please input a duration!', required: true }]}>
                <InputNumber min={1} />
              </Form.Item>
            </Col>
            <Col flex="none">
              <Form.Item label="Type d'unité" name="timeUnit">
                <Select
                  options={[
                    { label: 'Mensuel', value: 'm' },
                    { label: 'Hebdomadaire', value: 's' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Ajouter au reporting" name="addToReport" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Sortir en PDF" name="exportPDF" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
          </Form.Item>
        </Form>
        <Text type="danger">{msgErr}</Text>
      </Space>
    </>
  );
};

export default GiftCode;
